// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-container.modal-multisize{max-width:100vw}.size-1 .modal-container.modal-multisize{width:280px;padding:20px 15px}.size-2 .modal-container.modal-multisize{width:512px;padding:20px 30px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
